import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addRate } from 'api/wage/addRate'
import { wageRuleKeys } from './keys'

export const useAddRateMutation = (ruleId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof addRate>[0]) => addRate(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: wageRuleKeys.byId(ruleId),
      })
    },
  })
}
